import React from 'react';
import { Polyline } from 'react-leaflet';

const polylineLength = 200;
export const SegmentedPolyline = ({ route }) => {
  const segmentSize = polylineLength / 3;
  const start = route.slice(-segmentSize);
  const middle = route.slice(-segmentSize * 2, -segmentSize + 1);
  const end = route.slice(-segmentSize * 3, -(segmentSize * 2) + 1);

  return (
    <>
      {start.length && (
        <Polyline color={'#FF69B4'} stroke={true} positions={start} weight={2} />
      )}
      {middle.length && (
        <Polyline
          color={'#FF69B4'}
          stroke={true}
          positions={middle}
          weight={2}
          opacity={0.8}
        />
      )}
      {end.length && (
        <Polyline
          color={'#FF69B4'}
          stroke={true}
          positions={end}
          weight={1}
          opacity={0.6}
        />
      )}
    </>
  );
};
